// Backoffice shell constants and environment naming.
// These are display/labeling constants only. They must never be used to
// grant access, scope, or permissions  -  role/data scope always comes from
// backend authorization (see docs/superpowers/specs/... section 4.3).

export const ENVIRONMENTS = Object.freeze({
  DEVELOPMENT: "development",
  TEST: "test",
  STAGING: "staging",
  PRODUCTION: "production",
});

export const KNOWN_ENVIRONMENTS = Object.freeze(Object.values(ENVIRONMENTS));

export const ENVIRONMENT_LABELS_TH = Object.freeze({
  [ENVIRONMENTS.DEVELOPMENT]: "พัฒนา (Development)",
  [ENVIRONMENTS.TEST]: "ทดสอบ (Test)",
  [ENVIRONMENTS.STAGING]: "ทดลองใช้งาน (Staging)",
  [ENVIRONMENTS.PRODUCTION]: "ใช้งานจริง (Production)",
});

// Display-only role labels. Communication badges only  -  never permission
// selectors. Actual RBAC/data-scope enforcement happens on the backend.
export const ROLE_LABELS = Object.freeze({
  ADMIN: "Admin",
  SUPER_AGENT: "Super Agent",
  PLC: "บมจ",
  AGENT: "Agent",
  EMPLOYER: "Employer",
});

// Stable Android package identity recorded here so every future backoffice
// screen and mobile packet references the same value. Must not change
// without explicit owner approval (see requirement spec section 3.0).
export const ANDROID_PACKAGE_ID = "com.innovancex.workmatex";

export const SHELL = Object.freeze({
  DEFAULT_APP_NAME: "Workmate X Backoffice",
  DEFAULT_SUPPORT_CONTACT: "ops@workmatex.com",
  RUNTIME_CONFIG_PATH: "/runtime-config.json",
});
